enum QUERY_PARAMS {
  CT = 'ct',
  CTX = 'ctx',
}

enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C',
}

enum ProfileSource {
  URL = 'url',
  PAGE = 'page',
  PERSISTED = 'persisted',
  USER = 'user',
  PAL = 'pal',
}

enum CustomerGroupType {
  B2C_DEFAULT = 'B2C_DEFAULT',
  B2B_DEFAULT = 'B2B_DEFAULT',
}

enum ContextType {
  B2B = 'B2B',
  B2C = 'B2C',
}

enum IdentityProvider {
  BIAS = 'BIAS',
  CIAS = 'CIAS',
}

enum REGION {
  EU = 'EU',
  AP = 'AP',
  NA = 'NA',
}

export { REGION, QUERY_PARAMS, BusinessType, ProfileSource, ContextType, CustomerGroupType, IdentityProvider };
